import { render, staticRenderFns } from "./CourseMaterialDownloadPage.vue?vue&type=template&id=5baa1430&scoped=true"
import script from "./CourseMaterialDownloadPage.vue?vue&type=script&lang=js"
export * from "./CourseMaterialDownloadPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baa1430",
  null
  
)

export default component.exports